import React, { useEffect } from 'react';

import S from 'constants/string.const';

import { PW } from 'notification/constants';

const NotificationAlert = ({ autoDismissTime, closeNotification, id, isPermissionToast, messageText, showCloseBtn, type }) => {
  useEffect(() => {
    if (!autoDismissTime) return undefined;

    const timeoutId = setTimeout(() => closeNotification(id), autoDismissTime);
    return () => clearTimeout(timeoutId);
  }, [autoDismissTime, closeNotification, id]);

  const rootPwId = isPermissionToast ? PW.permissionToast : PW.alert;
  const messagePwId = isPermissionToast ? PW.permissionToastMessage : PW.alertMessage;
  const closePwId = isPermissionToast ? PW.permissionToastClose : PW.alertClose;

  return (
    <div data-bem="NotificationAlert" data-pw-id={rootPwId} data-testid={rootPwId} className={`alert ${type} animated zoomIn`}>
      <span data-bem="NotificationAlert__message-text" data-pw-id={messagePwId} data-testid={messagePwId}>
        {messageText}
      </span>
      {showCloseBtn && (
        <button data-bem="NotificationAlert__close-button" data-pw-id={closePwId} data-testid={closePwId} type="button" onClick={() => void closeNotification(id)}>
          {S.markX}
        </button>
      )}
    </div>
  );
};

export default NotificationAlert;
